export default "__VITE_ASSET__1I9hwsD4__"